<template>
  <Container type="card-full">
    <div slot="header"  class="header">
      <vxe-button  class="vxe-btn"  @click="checkDialog(2)"
                   v-if="+type === 4 && +$store.getters.loginUser.comtype === 1
                   && +project.projectjjbgstatus === 1
                   && +project.cositemapsynergyway === 1"
                   :loading="btnLoading">提交</vxe-button>
      <vxe-button  class="vxe-btn"  @click="checkDialog(3)" v-if="displayOk"  :loading="btnLoading">审核</vxe-button>
      <vxe-button  class="vxe-btn"  @click="lodopPrint" :loading="btnLoading">打印</vxe-button>
      <!-- <el-button @click="close">关闭</el-button> -->

        <span class="status">{{project.projectjjbgstatusdesc}}</span>
        <span class="statusdesc" v-if="project.projectsubmitdesc">提交意见：{{project.projectsubmitdesc}}</span>
        <span class="statusdesc" v-if="project.projectcgcheckdesc">审核意见：{{project.projectcgcheckdesc}}</span>

    </div>

    <div class="notice-content" id="px" ref="px">
      <h2 class="title">
        采购报告
      </h2>
       <div class="item">
         项目名称: &nbsp;{{project.projectname}}
      </div>
      <div class="item">
        项目编号: &nbsp;{{project.projectcode}}
      </div>
      <div class="item">
        采购人: &nbsp;{{project.pcomfullname}}
      </div>
      <div class="item">
        采购代理人: &nbsp;{{project.comfullname}}
      </div>
      <h2 class="field">一、项目简介</h2>
      <div class="text">
        {{project.acomfullname}}受{{project.pcomfullname}}的委托,对【{{project.projectname}}】(项目编号【{{project.projectcode}}】)进行网上报价采购,经批准,本项目预算人民币{{project.projectlimitamt | qfwVal}}元，
        本项目竞价用【{{project.projectdoneflgdesc}}】。根据采购工作计划,本次采购于{{project.projectctime | shortDate}}在采购人指定发布媒体({{$store.getters.loginUser.cosreturnurl}})登载竞价公告。
      </div>
      <h2 class="field">二、简要项目说明</h2>
      <table border="1">
          <tr>
            <td width="80" class="border">采购的物品</td>
            <td width="80" class="border">数量</td>
            <td width="80" class="border">品牌</td>
            <td width="80" class="border">规格</td>
            <td width="80" class="border">型号</td>
            <td width="80" class="border">交货</td>
            <td width="80" class="border">定标规则</td>
          </tr>
          <tr v-for="(pmmx, index) in project.pmmxs" :key="index">
            <td width="80" align="center">{{pmmx.pmmxname}}</td>
            <td width="80" align="center">{{pmmx.pmmxqty | qfwVal}}</td>
            <td width="80" align="center">{{pmmx.pmmmake}}</td>
            <td width="80" align="center">{{pmmx.pmmspec}}</td>
            <td width="80" align="center">{{pmmx.pmmtype}}</td>
            <td width="80"  align="center">按要求交货</td>
            <td width="80" align="center">{{project.projectdoneflgdesc}}</td>
          </tr>
      </table>
      <h2 class="field">三、竞价开始和截止</h2>
      <div class="item">
        1. 竞价开始时间为: {{project.prsbjbegtime | newDate}}, 00竞价截止时间为: {{project.prsbjendtime | newDate}}
      </div>
      <div class="item">
        2. 参与报名的供应商共{{project.allPsuList ? project.allPsuList.length : 0}}家,他们的联系方式如下:
      </div>
      <table border="1">
        <tr>
          <td width="40" class="border">序号</td>
          <td class="border">供应单位</td>
          <td width="100" class="border">联系人</td>
          <td  width="100" class="border">联系方式</td>
        </tr>
        <tr v-for="(psu, index) in project.allPsuList" :key="index">
          <td width="40" align="center">{{index + 1}}</td>
          <td  align="center">{{psu.comfullname}}</td>
          <td width="100" align="center">{{psu.comcontact}}</td>
          <td width="100" align="center">{{psu.comtel}}</td>
        </tr>
      </table>
      <div class="item">
        3. 竞价过程
      </div>
      <table border="1">
        <tr>
          <td width="40" class="border">序号</td>
          <td class="border">供应单位</td>
          <td class="border">报价过程</td>
        </tr>
        <tr v-for="(pbr, index) in pbrjjList" :key="index">
          <td width="40" align="center">{{pbr.pbtseq}}</td>
          <td  align="center">{{pbr.comfullname}}</td>
          <td align="center">{{pbr.pbrtime | newDate}} 报价: {{pbr.pbramt | qfwVal}}元</td>
        </tr>
      </table>
      <div class="item">
        4. 竞价结果及价格排名(由低到高)
      </div>
       <table border="1">
        <tr>
          <td width="40" class="border">序号</td>
          <td class="border">供应单位</td>
          <td class="border">最终报价</td>
        </tr>
         <tr v-for="(pbr, index) in pbryxList" :key="index">
          <td width="40" align="center">{{index + 1}}</td>
          <td align="center">{{pbr.comfullname}}</td>
          <td align="center">{{pbr.pbramt | qfwVal}}元</td>
        </tr>
      </table>
      <div class="item">
        5. 竞价过程文件
        <p>在电子竞价过程中,各报价供应商均上传了报名文件,列表如下:</p>
      </div>
       <table border="1">
        <tr>
          <td width="40" class="border">序号</td>
          <td class="border">供应单位</td>
          <td class="border">附件</td>
        </tr>
         <tr v-for="(pbr, index) in pbryxList" :key="index">
          <td width="40" align="center">{{index + 1}}</td>
          <td  align="center">{{pbr.comfullname}}</td>
          <td align="center">
            <div class="file" @click="downFile(pbr.appendurl)"><a :src="$store.getters.uploadAddr + pbr.appendurl">{{pbr.appendfilename}}</a>
            </div>
          </td>
        </tr>
      </table>
      <h2 class="field">四、授权建议</h2>
      <div class="item">
        根据竞价结果和定标原则,现作如下授标建议:
        <!--<div v-for="(psu, index) in project.psuList" :key="index" v-if="+psu.psubidflg === 1">-->
        <div v-if="pbryxList.length">
          <p><span>【拟成交供应商】</span> <span>{{pbryxList[0].comfullname}}</span><span style="margin-left: 30px">【报价】</span><span>{{(pbryxList[0].pbramt) | qfwVal}} 元</span></p>
        </div>
      </div>
      <div style="text-align:right">
        <p>{{$store.getters.loginUser.comfullname}}</p>
        {{now}}
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="status===2?'提交':'审核'" :visible.sync="dialogVisible" width="380px"
               :modal-append-to-body="false">
      <div v-if="status === 3">
        <div class="view-container ">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">报告结果</div>
                <div class="view-value">
                  <el-radio v-model="projectjjbgstatus" :label="3">同意</el-radio>
                  <el-radio v-model="projectjjbgstatus" :label="4">不同意</el-radio>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">审核意见</div>
                <div>
                  <el-input type="textarea" :autosize="{ minRows: 2}"
                            v-model.trim="checkdesc" :maxlength="255" show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button class="vxe-btn" @click="submit(status)" :loading="btnLoading">保存</vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="status === 2">
        <div class="view-container ">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">提交意见</div>
                <div>
                  <el-input type="textarea" :autosize="{ minRows: 2}"
                            v-model.trim="checkdesc" :maxlength="255" show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button class="vxe-btn" @click="submit(status)" :loading="btnLoading">保存</vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  /* eslint-disable */  
  import {getLodop} from '@/assets/js/LodopFuncs'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  import request from '@/utils/request'
  import config from '../../assets/config'
  import common from '@/mixin/common'
  let LODOP
  export default {
    name: 'projectNotice',
    props: {
      cproject: {
        type: Object,
        default: function () {
          return {
          }
        }
      },
      ctype: Number
    },
    mixins: [common],
    filters:{
      newDate(value){
        return dayjs(value).format('YYYY年MM月DD日 HH:mm:ss')
      },
      shortDate(value){
        return dayjs(value).format('YYYY年MM月DD日')
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    computed: {
      displayOk () {
        if (+this.project.projectjjbgstatus < 3) {
          if (+this.project.projecttype === 2) {
            return true
          } else if (+this.project.projecttype === 1 && +this.project.cositemapsynergyway === 2) {
            return true
          } else if ((+this.type === 4 && +this.$store.getters.loginUser.comtype === 2 && +this.project.projectjjbgstatus === 2)) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    data () {
      return {
        projectjjbgstatus: '',
        checkdesc: '',
        status: 0,
        dialogVisible: false,
        projectid: this.$route.params.projectid,
        type: this.$route.params.type,
        btnLoading: false,
        project: {},
        now: '',
        resultList: [],
        pbryxList: [],
        pbrjjList:[]
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getProject()
    },
    // deactivated () {
    //   console.log(this.$data)
    //   Object.assign(this.$data, {})
    // },
    mounted () {
      this.init()
      this.getProject()
    },
    methods: {
      async init() {
        this.now = dayjs().format('YYYY年MM月DD日')
        this.projectid = this.cproject.projectid || this.$route.params.projectid
        this.type = this.ctype || this.$route.params.type
        this.btnLoading = false
        this.project = {}
      },

      async getProject () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res[0]

        // 竞价过程
        this.pbrjjList = this.project.pbrList
        // this.pbrjjList.length ?this.pbrjjList.sort((t1, t2) => Number(t1.pbramt) - Number(t2.pbramt)) : this.pbrjjList
        this.pbryxList = this.project.pbrList.length ? this.project.pbrList.filter(v => +this.project.prsbjtimes===+v.pbtseq && v.psuas && Number(v.psuas)>0) : []
        // console.log(this.pbryxList)
        // 低到高排序
       // this.pbryxList.length ? this.pbryxList.sort((t1, t2) => Number(t1.psubidorder) - Number(t2.psubidorder)) : this.pbryxList
      },
      async submit (status) {
        if(status === 3) {
          if (+this.projectjjbgstatus<3) {
            this.$message.warning(`请选择报告结果！`)
            return
          }
          if (+this.projectjjbgstatus === 4 && !this.checkdesc) {
            this.$message.warning(`请输入审核意见！`)
            return
          }
        }
        if (status === 2) {
          this.project.projectjjbgstatus = status
        } else {
          this.project.projectjjbgstatus = this.projectjjbgstatus
        }
        let data = await request({
          
          url: '/xmgl/project/projectSubmitJjbg',
          method: "post",
          data: {
            projecttype: +this.project.projecttype,
            projectid: this.project.projectid,
            userid: this.$store.getters.loginUser.userid,
            projectjjbgstatus: this.project.projectjjbgstatus,
            projectcgcheckdesc: this.checkdesc,
            projectsubmitdesc: this.checkdesc
          }
        })
        if (data.issuccess===1) {
          let projectjjbgstatusdesc = status === 2 ? '提交' : '保存'
          this.$message.success(`${projectjjbgstatusdesc}成功！`)
          this.getProject()
          this.dialogVisible = false
          this.status = 0
        } else {
          this.$message.error(`${projectjjbgstatusdesc}失败！`)
        }
      },
      async checkDialog (status) {
        this.dialogVisible = true
        this.status = status
      },
      close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async lodopPrint () {
        var style = document.createElement('link')
        style.href = 'http://120.78.91.121:9600/upload/20200806/1596702543014.css'
        style.rel = 'stylesheet'
        style.type = 'text/css'
        document.getElementById("px").appendChild(style)
        LODOP = await getLodop()
        if (LODOP) {
          LODOP.SET_PRINT_STYLE("FontSize",10);
          LODOP.ADD_PRINT_HTM(	10, 0, "90%", "80%",document.getElementById("px").innerHTML);
          LODOP.PREVIEW();
        }
      }
    }
  }
</script>
<style lang="scss" scoped>

    .status {
      color: red;
      font-size: 14px;
      padding-left: 10px;
    }
    .statusdesc {
      font-size: 14px;
      padding-left: 20px;
      color: #606266;
    }

  .notice-content {
    display: flex;
    flex-direction: column;
    // align-items: center;
    /*height: 100vh;*/
    text-align: center;
    overflow: auto;
    font-weight: bold;
    margin-left: 20px;
  }
  .title {
    font-size: 18px;
    color: rgb(255,0,0);
    word-wrap: break-word;
    font-weight: bold;
  }
  .desc {
    color: rgb(255,0,0);
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    margin: 10px 0
  }
  .line, .line1 {
    width: 100%;
    background: rgb(255,0,0);
  }
  .line {
     height: 4px;
     margin-bottom: 4px
  }
  .line1 {
    height: 2px;
  }
  .text {
    padding-left: 2px;
    line-height: 22px;
    text-align: left;
    text-indent: 16px;
    margin-top: 8px;
    font-size: 14px;
  }
  .item {
    text-align: left;
    font-size: 14px;
    margin-top: 8px
  }
  .zr {
    display: flex;
    align-items:center;
    border-top: 1px solid rgb(192,192,192);
    border-bottom: 1px solid rgb(192,192,192);
    margin-bottom: 4px;
  }
  .zr span {
    width: 180px;
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
  }
  .othergg {
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }
  .othergg .item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(192,192,192);
    line-height: 28px;
    margin-bottom: 4px
  }
  table{
    border-collapse: collapse;
    margin-top: 10px;
    font-size: 14px;
  }
  td {
    text-align: center;
  }
  table,table tr td {
    border:1px solid rgb(192,192,192);
  }
  table tr td{
    padding: 5px 10px;
  }
  .field{
    text-align: left;
    font-size: 16px
  }
  .file {
    color: #2f74ff;
    cursor: pointer;
  }
</style>
